
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.999 25L15 15m.001 10L25 15","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M36.667 20c0-9.205-7.462-16.667-16.667-16.667-9.205 0-16.666 7.462-16.666 16.667 0 9.205 7.461 16.667 16.666 16.667S36.667 29.205 36.667 20z","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    